import styled from 'styled-components';
import colors from '@theme/colors';

const TopTextFieldContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const MainTextFieldContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const LeftFieldContainer = styled.div`
  width: 60%;
`;

const RightFieldContainer = styled.div`
  width: 39%;
`;

const FieldContainer = styled.div`
  border-top: solid 1px ${colors.LIGHT_GREY};
  padding-top: 10px;
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;

const MainFieldsContainer = styled.div`
  max-width: 400px;
`;

const MainFieldsContainerFixed = styled.div`
  width: 400px;
`;

export default {
  TopTextFieldContainer,
  MainTextFieldContainer,
  LeftFieldContainer,
  RightFieldContainer,
  FieldContainer,
  MainFieldsContainer,
  MainFieldsContainerFixed,
};



// WEBPACK FOOTER //
// ./components/layout/ConferenceCallInformation.js